"use client";

import { type ReactNode } from "react";
import {
  RemittanceConfigProvider,
  initRemittanceConfig,
} from "cy-remittance-config";
import { remittanceConfig } from "@/config/remittance";

// Initialize the module store for non-React code (utilities, server actions)
initRemittanceConfig(remittanceConfig);

interface RemittanceProviderProps {
  children: ReactNode;
}

/**
 * Provides remittance configuration to all child components.
 * Also initializes the module store for non-React code.
 */
export function RemittanceProvider({ children }: RemittanceProviderProps) {
  return (
    <RemittanceConfigProvider config={remittanceConfig}>
      {children}
    </RemittanceConfigProvider>
  );
}
